import TopicGroup from '@templates/TopicGroup';
import { getSliderBroker } from '@utils/sortBroker';
import { getPostMediaUrl } from '@utils/thumbnailUtil';
import { getTopicGroupCacheById } from 'cache-service/topicGroup';
import { getWpTopicGroupTreeByCodes } from 'cache-service/topicGroupTree';
import { getAllForexBrokerDataCache } from 'cache-service/wpBrokerData';
import { getFeaturePostsCache, getMostViewPostsCache } from 'cache-service/wpGroupPost';
import { getPostByWpIds } from 'cache-service/wpPost';
import React from 'react';

export const getStaticProps = async ({ pageNextJs }) => {
  const data = await getTopicGroupCacheById(pageNextJs.originalId);
  const listId = (data.acf.posts || []).map((item) => item.post.ID);
  const posts = await getPostByWpIds(listId);
  
  //menu feature posts
  const featurePostGroups = await getFeaturePostsCache();
  const forexBrokersData = await getAllForexBrokerDataCache();
  const newSlickBrokers = getSliderBroker(forexBrokersData);

  const filteredData = {
    title: {
      rendered: data.title.rendered,
    },
    acf: { path: data.acf.path, name: data.acf.name },
    path: data.acf.path,
  };

  let filteredPosts = posts.map((post) => {
    return {
      id: post.id,
      excerpt: { rendered: post.excerpt.rendered },
      slug: post.slug,
      title: { rendered: post.title.rendered },
      thumbnail: getPostMediaUrl(post) || post?.thumbnail,
      date: post.date,
      author: post.author || null,
      last_modified: post.postModified || null,
    };
  });

  // most view posts
  const mostViewPostsRes = await getMostViewPostsCache();
  const mostViewPostsGroup = mostViewPostsRes[0].acf.group_posts
    .slice(0, 10)
    .filter((item) => item.post);
  const mostViewIds = mostViewPostsGroup.map((item) => item.post?.ID);
  let mostViewPosts = await getPostByWpIds(mostViewIds);

  const newMostViewPosts = mostViewPosts.map((p) => {
    const editedTitlePost = mostViewPostsGroup.find((item) => item.post?.ID == p.wpPostId);
    const manualTitle = { rendered: editedTitlePost.manual_title };

    return {
      id: p.id,
      title: manualTitle || null,
      date: p.date,
      excerpt: p.excerpt || null,
      thumbnail: p.thumbnail || null,
      slug: p.slug,
      author: p.author,
    };
  });

  //breadcrumb
  const breadcrumbPageTopic = [
    {
      url: data.acf.path,
      name: data.acf.name,
    },
  ];

  //topic tree
  const topicTree = await getWpTopicGroupTreeByCodes([
    'kien-thuc-nen-tang-crypto',
    'cac-he-sinh-thai-crypto',
    'phan-tich-dau-tu-crypto',
    'kien-thuc-forex-nen-tang',
    'phan-tich-va-giao-dich-forex',
    'kien-thuc-forex-nang-cao',
  ]);

  return {
    props: {
      pageNextJs,
      data: filteredData,
      posts: filteredPosts,
      newSlickBrokers: newSlickBrokers,
      newMostViewPosts: newMostViewPosts,
      breadcrumbPageTopic: breadcrumbPageTopic,
      isTopicPage: true,
      topicTree: topicTree,
      featurePostGroups: featurePostGroups,
    },
  };
};

const TopicalGroupWrapper = (props) => {
  return props.data ? <TopicGroup {...props} /> : null;
};

export default TopicalGroupWrapper;
